import { defineStore } from "pinia";
import ApiApps from "@/apis/ApiApps";
import { catchable } from "./piniaUtils";

export const useAdminsStore = defineStore("admin", () => {
  const createDefaultSequences = appId =>
    catchable({ t: () => ApiApps.createDefaultSequences(appId), loadable: true });
  const enablePinpointEmails = appId =>
    catchable({ t: () => ApiApps.enablePinpointEmails(appId), loadable: true });
  const syncSfmc = appId => catchable({ t: () => ApiApps.syncSfmc(appId), loadable: true });
  const purgeSfmc = appId => catchable({ t: () => ApiApps.purgeSfmc(appId), loadable: true });
  const publishSdk = ({ appId, type = "javascript", sourceVersion }) =>
    catchable({ t: () => ApiApps.publishSdk(appId, type, sourceVersion), loadable: true });
  const imagewizUpdateCfDistro = ({ appId, all = false }) =>
    catchable({ t: () => ApiApps.imagewizUpdateCfDistro(appId, all), loadable: true });
  const invalidateCache = appId =>
    catchable({ t: () => ApiApps.invalidateCache(appId), loadable: true });
  const refreshTraitValues = appId =>
    catchable({ t: () => ApiApps.refreshTraitValues(appId), loadable: true });
  const createPinpointApp = appId =>
    catchable({ t: () => ApiApps.createPinpointApp(appId), loadable: true });
  const createSampleData = appId =>
    catchable({ t: () => ApiApps.createSampleData(appId), loadable: true });

  return {
    createDefaultSequences,
    enablePinpointEmails,
    imagewizUpdateCfDistro,
    syncSfmc,
    purgeSfmc,
    publishSdk,
    invalidateCache,
    refreshTraitValues,
    createPinpointApp,
    createSampleData,
  };
});
